import React from 'react';
import { Box } from '@mui/material';
import MuLogo from '../SideNavbar/MuLogo';
import { palette, spaces } from '../../../assets/styles/themes/tokens';
import { customSizes } from '../../../assets/styles/themes/tokens';
import useRouter from '../../../utils/useRouter';
import { routes } from '../../../constants';
import useScreenSize from '../../../utils/useScreenSize';

interface PublicLayoutHeaderProps {
  rightContent?: React.ReactNode;
}

/**
 * Reusable header component for public pages.
 * Provides consistent logo placement and optional right-side content.
 */
const PublicLayoutHeader: React.FC<PublicLayoutHeaderProps> = ({ rightContent }) => {
  const { router } = useRouter();
  const { isXsScreen, isSmScreen } = useScreenSize();
  const isSmallScreen = isXsScreen || isSmScreen;

  const handleLogoClick = () => {
    router.push(`/${routes.login.root}`);
  };

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        width: '100%',
        height: customSizes.sideNavbar.headerHeight.desktop,
        borderBottom: `1px solid ${palette.elevation.outlined}`,
        backgroundColor: palette.background.paperElevation2,
      }}
      data-testid='public-layout-header'
    >
      {isSmallScreen && (
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            padding: spaces.md,
            borderRight: `1px solid ${palette.elevation.outlined}`,
          }}
        >
          <MuLogo 
            variant='full' 
            onClick={handleLogoClick}
          />
        </Box>
      )}
      {rightContent && (
        <Box
          sx={{
            display: 'flex',
            justifyContent: 'flex-end',
            alignItems: 'center',
            padding: spaces.md,
            flex: 1,
          }}
        >
          {rightContent}
        </Box>
      )}
    </Box>
  );
};

export default PublicLayoutHeader;

